import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigation = [
    { name: 'Services', href: '/#services' },
    { name: 'Blog', href: '/blog' },
    { name: 'About', href: '/about' },
  ];

  return (
    <header className="relative flex items-center justify-between whitespace-nowrap border-b border-solid border-b-border px-10 py-4">
      {/* Logo */}
      <Link to="/" className="flex items-center gap-3 text-white">
        {/* <Logo className="size-14 text-secondary" /> */}
        <h2 className="text-white text-3xl font-semibold leading-tight tracking-[-0.015em]">
          recalibr<span className="text-secondary">.ai</span>
        </h2>
      </Link>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center gap-6 text-base font-medium text-gray-300">
        {navigation.map((item) => (
          <Link
            key={item.name}
            to={item.href}
            className="transition-colors hover:text-white"
          >
            {item.name}
          </Link>
        ))}
      </nav>

      {/* Contact Button */}
      <Link
        to="/contact"
        className="hidden md:flex min-w-[84px] cursor-pointer items-center justify-center overflow-hidden rounded-md h-12 px-6 bg-secondary text-gray-900 text-base font-bold leading-normal tracking-[0.015em] transition-colors hover:bg-cyan-400"
      >
        <span className="truncate">Contact Us</span>
      </Link>

      {/* Mobile menu button */}
      <button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className="md:hidden p-2 rounded-md text-gray-300 hover:text-white"
      >
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-primary border-t border-border z-50 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setIsMenuOpen(false)}
                className="block text-white text-lg py-2 hover:text-secondary transition-colors"
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setIsMenuOpen(false)}
              className="block w-full mt-4 cursor-pointer items-center justify-center overflow-hidden rounded-md h-12 px-4 bg-secondary text-gray-900 text-base font-bold leading-normal tracking-[0.015em] transition-colors hover:bg-cyan-400 text-center"
            >
              <span className="truncate">Contact Us</span>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
